<template>
  <div class="container-fluid py-4">

    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-person fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Patients</h2>
      </div>
      <button
        class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0"
        @click="creation()"
        v-if="$store.getters.hasPermission('PATIENT_CREATE')"
      >
        <i class="bi bi-plus-circle me-1"></i>
      </button>
    </div>

    <!-- Filtres et recherche -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Nom, prénom, téléphone, dossier..."
            class="form-control form-control-clinique"
          >
        </div>
        <div class="col-6 col-md-2">
  <label class="form-label fw-semibold">Groupe sanguin</label>
  <select v-model="groupeSanguinFilter" class="form-select form-select-clinique">
    <option value="">Tous</option>
    <option v-for="gs in groupesSanguins" :key="gs" :value="gs">{{ gs }}</option>
  </select>
</div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Erreur -->
    <div v-if="loadError" class="alert alert-danger d-flex justify-content-between align-items-center">
      <span>Impossible de charger les patients.</span>
      <button class="btn btn-sm btn-outline-danger" @click="getpatients">Réessayer</button>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;"></div>
      <p class="mt-3">Chargement des patients...</p>
    </div>

    <!-- Tableau moderne -->
    <div v-else class="card shadow-sm rounded card-clinique">
      <div class="table-responsive overflow-auto" :class="{ 'opacity-50': isFetching }">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique w-100">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>N° Dossier</th>
              <th>Nom</th>
              <th>Prénom</th>
              <th class="d-none d-sm-table-cell">Adresse</th>
              <th class="d-none d-sm-table-cell">Téléphone</th>
              <th class="d-none d-sm-table-cell">Groupe sanguin</th>
              <th class="d-none d-md-table-cell">Nbre. Consultation</th>
              <th class="d-none d-md-table-cell">Consult-Terminée</th>
              <th class="d-none d-lg-table-cell">Enregistré par</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(patient, index) in paginatedPatients" :key="patient.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ formatDate(patient.createdAt) }}</td>
              <td>{{ patient.numeroDossier || '-' }}</td>
              <td>{{ patient.nom }}</td>
              <td>{{ patient.prenom }}</td>
              <td class="d-none d-sm-table-cell">{{ patient.adresse || '-' }}</td>
              <td class="d-none d-sm-table-cell">{{ patient.telephone || '-' }}</td>
              <td class="d-none d-sm-table-cell">{{ patient.groupeSanguin || '-' }}</td>
              <td class="d-none d-md-table-cell">{{ patient.nombreConsultations ?? 0 }}</td>
              <td class="d-none d-md-table-cell">{{ patient.nombreConsultationsTerminees ?? 0 }}</td>
              <td class="d-none d-lg-table-cell">
                <strong>{{ patient.createdByNom }} {{ patient.createdByPrenom }}</strong>
              </td>
              <td>
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-outline-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    v-dropdown-fixed
                  >
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="$store.getters.hasPermission('PATIENT_DOSSIER')">
                      <a class="dropdown-item" @click="dossier(patient.id)">Dossier</a>
                    </li>
                    <li v-if="$store.getters.hasPermission('PATIENT_EDIT')">
                      <a class="dropdown-item" @click="modifier(patient.id)">Modifier</a>
                    </li>
                    <li v-if="$store.getters.hasPermission('PATIENT_DELETE')">
                      <a class="dropdown-item text-danger" @click="supprimer(patient.id)">Supprimer</a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="paginatedPatients.length === 0">
              <td colspan="11" class="text-center py-3">Aucune donnée disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center p-3 flex-wrap gap-2">
        <small class="text-muted">
          {{ filteredPatients.length }} patient(s)
          <span v-if="searchQuery"> (sur {{ patients.length }} au total)</span>
        </small>

        <ul class="pagination pagination-modern flex-wrap mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 || isFetching }">
            <button class="page-link" @click="changePage(currentPage - 1)" :disabled="isFetching">Précédent</button>
          </li>
          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)" :disabled="isFetching">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages || isFetching }">
            <button class="page-link" @click="changePage(currentPage + 1)" :disabled="isFetching">Suivant</button>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      isLoading: true,
      isFetching: false,
      isFirstLoad: true,
      loadError: false,
      groupeSanguinFilter: '',
      groupesSanguins: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'],

      searchQuery: '',
      itemsperpage: 50,
      orderBy: 'pat.createdAt',
      sortOrder: 'desc',

      // Liste COMPLETE chargée une fois (la recherche/pagination
      // se fait ensuite entièrement côté client, voir computed
      // ci-dessous) puisque l'API n'implémente pas le filtre `search`.
      patients: [],
      currentPage: 1,

      itemsPerPageT: [50, 100, 150, 200],
      orderByTabs: {
        Nom: 'pat.nom',
        Prénom: 'pat.prenom',
        Création: 'pat.createdAt'
      },
      sortOrders: { Croissant: 'asc', Décroissant: 'desc' },

      _searchTimeout: null
    };
  },

  computed: {

    /* =====================================================
       FILTRAGE CÔTÉ CLIENT
       (le backend ignore le paramètre `search`, donc on filtre
       nous-mêmes sur la liste complète déjà chargée)
    ====================================================== */
    filteredPatients() {
    let list = this.patients;

    if (this.groupeSanguinFilter) {
      list = list.filter(p => p.groupeSanguin === this.groupeSanguinFilter);
    }

    if (!this.searchQuery.trim()) return list;

    const q = this.searchQuery.trim().toLowerCase();

    return list.filter(p => {
      const nom = (p.nom || '').toLowerCase();
      const prenom = (p.prenom || '').toLowerCase();
      const telephone = (p.telephone || '').toLowerCase();
      const dossier = (p.numeroDossier || '').toLowerCase();
      const groupeSanguin = (p.groupeSanguin || '').toLowerCase();

      return (
        nom.includes(q) ||
        prenom.includes(q) ||
        telephone.includes(q) ||
        dossier.includes(q) ||
        groupeSanguin.includes(q)
      );
    });
  },

    totalPages() {
      return Math.max(1, Math.ceil(this.filteredPatients.length / this.itemsperpage));
    },

    paginatedPatients() {
      const start = (this.currentPage - 1) * this.itemsperpage;
      return this.filteredPatients.slice(start, start + this.itemsperpage);
    }
  },

  methods: {

    formatDate(date) {
      if (!date) return '-';
      return dayjs(date).format('DD-MM-YYYY HH:mm');
    },

    creation() {
      this.$router.push({ name: 'create_patient' });
    },

    dossier(id) {
      this.$router.push({ name: 'information_personnelle', params: { id } });
    },

    modifier(id) {
      this.$router.push({ name: 'edit_patient', params: { id } });
    },

    async getpatients() {

      if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      } else {
        this.isFetching = true;
      }

      this.loadError = false;

      try {
        // On charge TOUTE la liste (tri géré par le serveur, mais
        // plus de pagination/search serveur puisqu'on filtre nous-mêmes).
        const response = await api.getItems('patients', {
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          itemsperpage: 100000
        });

        const { data } = response.data;
        this.patients = data || [];
        this.currentPage = 1;

      } catch (error) {
        console.error('Erreur lors de la récupération des patients :', error);
        this.patients = [];
        this.loadError = true;
      } finally {
        this.isLoading = false;
        this.isFetching = false;
      }
    },

    async supprimer(id) {
      if (!window.confirm("Voulez-vous vraiment supprimer ce patient ?")) return;

      try {
        await api.deleteItem('patients', id);
        this.getpatients();
      } catch (error) {
        console.error('Erreur suppression patient :', error);
        alert("Erreur lors de la suppression.");
      }
    },

    changePage(page) {
      if (page > 0 && page <= this.totalPages && !this.isFetching) {
        this.currentPage = page;
      }
    }
  },

  watch: {

    searchQuery() {
      clearTimeout(this._searchTimeout);
      this._searchTimeout = setTimeout(() => {
        this.currentPage = 1;
      }, 300);
    },
    groupeSanguinFilter() {
  this.currentPage = 1;
},

    itemsperpage() {
      this.currentPage = 1;
    },

    orderBy() {
      this.getpatients();
    },

    sortOrder() {
      this.getpatients();
    }
  },

  created() {
    this.getpatients();
  },

  beforeUnmount() {
    clearTimeout(this._searchTimeout);
  }
};
</script>

<style scoped>
/* ton CSS existant reste inchangé */
</style>